<template>
  <div class="container">
    <div class="pDownload">
      <!-- <div class="pDownload-container">
        <div class="pDownload-tit">产品下载</div>
        <div class="pDownload-tip">Product download</div>
      </div> -->
      <div class="pDownload-text">
        <div class="pDownload-left">
          <div class="text-box">
            <div class="text1">选择威笑</div>
            <div class="text1">让自己领先一步</div>
          </div>
          <div class="text2">10000+ 企业正在使用我们的产品降本增效</div>
          <div class="btn" @click="go">立即登录</div>
        </div>
        <div class="pDownload-right">
          <img src="@/assets/xiazai.gif" alt="" class="img" />
          <!-- <canvas class="canvas" id="pag"></canvas> -->
        </div>
      </div>
    </div>
    <div class="shouy-box">
      <div class="shou-text">
        <div class="text1">下载收银应用</div>
        <div class="text2">支持 iOS，Android，Windows，微信小程序版本</div>
        <div class="text3">
          <span class="span1-t">开发者：深圳市智百威科技发展有限公司</span>
          <span class="xian"></span>
          <span class="span2-t">版本号：</span>
          <span class="span2-t">V3.1.5</span>
          <span class="xian"></span>
          <span class="span3-t">应用权限</span>
          <span class="xian"></span>
          <span class="span3-t">隐私政策</span>
        </div>
      </div>
      <div class="shou-img-box">
        <div class="shou-img">
          <div class="div-img">
            <img :src="winurl" alt="" />
          </div>
          <div class="te">{{ wintext }}</div>

          <el-button
              type="primary"
              style="width: 120px"
              @click="clickdownloadWin"
              class="down-btn"
              >下载客户端</el-button>
        </div>
        <div class="shou-img">
          <div class="div-img">
            <img :src="Androidurl" alt="" />
          </div>
          <div class="te">{{ Androidtext }}</div>
          <el-button
              type="primary"
              style="width: 120px"
              @click="clickdownloadAndroid"
              class="down-btn"
              >下载客户端</el-button>
        </div>
        <div
          class="shou-img"
          @mouseenter="onmouseoverWx2"
          @mouseleave="mouseleaveWx2"
        >
          <div class="div-img">
            <img :src="wxurl" alt="" />
          </div>
          <div class="te">{{ wxtext }}</div>
        </div>
        <div
          class="shou-img"
          @mouseenter="onmouseoverPc2"
          @mouseleave="mouseleavePc2"
        >
          <div class="div-img">
            <img :src="pcurl" alt="" class="img" />
          </div>
          <div class="te">{{ pctext }}</div>
          <el-button
            type="primary"
            @click="downloadAPP"
            style="width: 120px"
            class="down-btn"
            >下载手机后台</el-button
          >
        </div>
        <div class="shou-img">
          <div class="div-img">
            <img :src="Androidurl" alt="" />
          </div>
          <div class="te">自助收银客户端</div>

          <el-button
            type="primary"
            @click="downloadAgentAPP"
            style="width: 120px"
            class="down-btn"
            >下载自助收银</el-button
          >
        </div>
        <!-- <div
          class="shou-img"
        >
          <div class="div-img div-img1">
            <img :src="winVoiceUrl" alt="" />
          </div>
          <div class="te">{{ pcVoiceText }}</div>
        </div> -->
        <!-- <el-popover placement="bottom" width="360" v-model="visible" trigger="hover">
            <div class="row-box">
              <div class="row-item" @click="clickdownloadWinVoice">
                <img src="@/assets/version4.png" class="icon" />
                <span class="text">Android远程工具</span>
                <span class="tip">安卓版本</span>
              </div>
              <div class="row-item" @click="clickdownloadWinRemote">
                <img src="@/assets/version3.png" class="icon" />
                <span class="text">Windows远程工具</span>
                <span class="tip">PC版本</span>
              </div>
            </div>
            <el-button
              type="primary"
              style="width: 134px"
              slot="reference"
              @click="visible = !visible"
              class="down-btn"
              >下载远程工具<i class="el-icon-arrow-down el-icon--right"></i
            ></el-button>
          </el-popover> -->
      </div>
    </div>
  </div>

  <!-- <div class="shouy-box">
      <div class="shou-text">
        <div class="text1">下载智慧零售应用</div>
        <div class="text2">支持 iOS，Android，macOS，Windows，微信小程序版本</div>
        <div class="text3">
          <span class="span1-t">开发者：东莞市丰派软件科技有限公司</span>
          <span class="xian"></span>
          <span class="span2-t">版本号：</span>
          <span class="span2-t">V5.6.9</span>
          <span class="xian"></span>
          <span class="span3-t">应用权限</span>
          <span class="xian"></span>
          <span class="span3-t">隐私政策</span>
        </div>
      </div>
      <div class="three-img-box">
        <div class="shou-img">
          <div class="div-img">
            <img src="@/assets/win1.png" alt="" />
          </div>
          <div class="te">智慧零售Windows客户端</div>
        </div>
        <div class="shou-img">
          <div class="div-img">
            <img src="@/assets/win3.png" alt="" />
          </div>
          <div class="te">智慧零售Android客户端</div>
        </div>
        <div class="shou-img">
          <div class="div-img">
            <img src="@/assets/win7.png" alt="" />
          </div>
          <div class="te">智慧零售后台小程序</div>
        </div>
      </div>
    </div>
    <div class="shouy-box">
      <div class="shou-text">
        <div class="text1">下载订货平台应用</div>
        <div class="text2">支持 iOS，Android，macOS，Windows，微信小程序版本</div>
        <div class="text3">
          <span class="span1-t">开发者：东莞市丰派软件科技有限公司</span>
          <span class="xian"></span>
          <span class="span2-t">版本号：</span>
          <span class="span2-t">V3.2.2 </span>
          <span class="xian"></span>
          <span class="span3-t">应用权限</span>
          <span class="xian"></span>
          <span class="span3-t">隐私政策</span>
        </div>
      </div>
      <div class="three-img-box">
        <div class="shou-img">
          <div class="div-img">
            <img src="@/assets/win7.png" alt="" />
          </div>
          <div class="te">订货商城</div>
        </div>
        <div class="shou-img">
          <div class="div-img">
            <img src="@/assets/win7.png" alt="" />
          </div>
          <div class="te">订货商城管理后台</div>
        </div>
        <div class="shou-img">
          <div class="div-img">
            <img src="@/assets/win3.png" alt="" />
          </div>
          <div class="te">订货商城后台APP</div>
        </div>
      </div>
    </div> -->
</template>
<script>
export default {
  name: "idownload",
  data() {
    return {
      visible: false,
      androidVisible: false,
      productMenu: 1,
      downloadcodeListOne: [
        {
          id: 1,
          tit: "收银系统手机后台",
          tip: "小程序扫码使用",
          img: require("@/assets/downloadcode1.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "1",
        },
        {
          id: 2,
          tit: "收银系统手机后台",
          tip: "APP扫码下载",
          img: require("@/assets/downloadcode2.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "",
        },
        {
          id: 3,
          tit: "收银系统客户端",
          tip: "Android版本下载",
          img: require("@/assets/downloadcode3.png"),
          codeimg: require("@/assets/downloadicon2.png"),
          downloadUrl:
            "https://www.ld8848.cn/vx_pos_android_new/vx_pos_android.apk",
        },
        {
          id: 4,
          tit: "收银系统客户端",
          tip: "Windows版本下载",
          img: require("@/assets/downloadcode4.png"),
          codeimg: require("@/assets/downloadicon2.png"),
          downloadUrl:
            "https://www.ld8848.cn/vx_pos_win/%E5%A8%81%E7%AC%91%E6%94%B6%E9%93%B6%20Setup%201.6.0.exe",
        }
      ],
      downloadcodeListtwo: [
        {
          id: 5,
          tit: "丰派移动管家",
          tip: "小程序扫码使用",
          img: require("@/assets/downloadcode5.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "1",
        },
        {
          id: 6,
          tit: "丰派智慧导购",
          tip: "小程序扫码使用",
          img: require("@/assets/downloadcode6.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "1",
        },
        {
          id: 7,
          tit: "丰派零售商城",
          tip: "小程序扫码使用",
          img: require("@/assets/downloadcode7.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "1",
        },
      ],
      downloadcodeListthree: [
        {
          id: 8,
          tit: "丰派订货商城",
          tip: "小程序扫码使用",
          img: require("@/assets/downloadcode8.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "1",
        },
        {
          id: 9,
          tit: "收银系统客户端",
          tip: "APP扫码下载",
          img: require("@/assets/downloadcode9.png"),
          codeimg: require("@/assets/downloadicon2.png"),
          downloadUrl: "",
        },
        {
          id: 10,
          tit: "收银系统手机后台",
          tip: "APP扫码下载",
          img: require("@/assets/downloadcode10.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "",
        },
        {
          id: 11,
          tit: "手机后台",
          tip: "ios版本下载",
          img: require("@/assets/downloadcode11.png"),
          codeimg: require("@/assets/downloadicon2.png"),
          downloadUrl: "",
        },
      ],
      winurl: require("@/assets/win1.png"),
      winVoiceUrl: require("@/assets/winRemote.png"),
      wintext: "Windows客户端",
      Androidurl: require("@/assets/win3.png"),
      Androidtext: "收银Android客户端",
      wxurl: require("@/assets/win7.png"),
      wxtext: "收银后台小程序",
      pcurl: require("@/assets/win5.png"),
      pctext: "收银后台APP",
      pcVoiceText: "安卓远程工具 ",
    };
  },
  // mounted() {
  //   try {
  //     PAGInit().then(async (PAG) => {
  //       const pagUrl = "https://img.fp1123.com/group1/M00/00/09/CgAFBmIeyG-ANH1pAADMZruJMdA118.pag";
  //       const fileBlob = await fetch(pagUrl).then((response) => {
  //         console.log(response);
  //         return response.blob();
  //       });
  //       // var fileBlob = pagUrl.blob();
  //       console.log(fileBlob);
  //       const file = new File(
  //         [fileBlob],
  //         pagUrl.replace(/(.*\/)*([^.]+)/i, "$2")
  //       );
  //       const pagFile = await PAG.PAGFile.load(file);
  //       document.getElementById("pag").width = pagFile.width();
  //       document.getElementById("pag").height = pagFile.height();
  //       const pagView = await PAG.PAGView.init(pagFile, "#pag");
  //       pagView.setRepeatCount(0);
  //       await pagView.play();
  //     });
  //   } catch (error) {
  //     console.log("err", error);
  //   }
  // },

  activated() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  methods: {
    downloadAPP() {
      let elink = document.createElement("a");
      elink.download = "手机后台下载";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/vx_pos_phone_admin_new/vx_pos_phone_admin.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    downloadAgentAPP() {
      let elink = document.createElement("a");
      elink.download = "手机后台下载";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/vx_pos_auto/vx_pos_auto.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    go() {
      location.href = "https://www.vx8848.com/vxPos/#/login";
    },
    onmouseoverWin1() {
      this.winurl = require("@/assets/win2.png");
      this.wintext = "点击下载";
    },
    mouseleaveWin1() {
      this.winurl = require("@/assets/win1.png");
      this.wintext = "Windows客户端";
    },
    clickdownloadWin() {
      let elink = document.createElement("a");
      elink.download = "Windows版本下载";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/vx_pos_win/%E5%A8%81%E7%AC%91%E6%94%B6%E9%93%B6%20Setup%201.6.0.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadai() {
      let elink = document.createElement("a");
      elink.download = "WindowsAI版本下载";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/vx_pos_win_ai/%E5%A8%81%E7%AC%91%E6%94%B6%E9%93%B6_AI%20Setup%201.6.0.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadWinVoice() {
      let elink = document.createElement("a");
      elink.download = "安卓远程工具 ";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/fp_help/fp_help.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadWinRemote() {
      let elink = document.createElement("a");
      elink.download = "Windows远程工具 ";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/fp_help/fprjwin.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    onmouseoverAndroid2() {
      this.Androidurl = require("@/assets/win4.png");
      this.Androidtext = "点击下载";
    },
    mouseleaveAndroid2() {
      this.Androidurl = require("@/assets/win3.png");
      this.Androidtext = "收银Android客户端";
    },
    clickdownloadAndroid() {
      let elink = document.createElement("a");
      elink.download = "Android版本下载";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/vx_pos_android_new/vx_pos_android.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadAndroidAi() {
      let elink = document.createElement("a");
      elink.download = "AndroidAi版本下载";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/vx_pos_android_ai_new/vx_pos_android_ai.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    onmouseoverWx2() {
      this.wxurl = require("@/assets/win8.png");
      this.wxtext = "微信扫描使用";
    },
    mouseleaveWx2() {
      this.wxurl = require("@/assets/win7.png");
      this.wxtext = "收银后台小程序";
    },
    onmouseoverPc2() {
      this.pcurl = require("@/assets/win6.png");
      this.pctext = "扫码下载";
    },
    onmouseoverPc3() {
      this.winVoiceUrl = require("@/assets/xzyy.png");
      this.pcVoiceText = "点击下载";
    },
    onmouseoverPc4() {
      this.winRemoteUrl = require("@/assets/xzyy.png");
      this.winRemoteText = "点击下载";
    },
    mouseleavePc3() {
      this.winVoiceUrl = require("@/assets/yyb.png");
      this.pcVoiceText = "安卓远程工具 ";
    },
    mouseleavePc4() {
      this.winRemoteUrl = require("@/assets/winRemote.png");
      this.winRemoteText = "Windows远程工具 ";
    },
    mouseleavePc2() {
      this.pcurl = require("@/assets/win5.png");
      this.pctext = "收银手机后台APP";
    },
    clickdownloadPc() {
      // this.$message.warning("暂无下载地址");
    },

    clickdownload(result) {
      if (result.downloadUrl && result.downloadUrl !== "1") {
        // this.$message.warning("下载地址");
        // window.open(result.downloadUrl);
        let elink = document.createElement("a");
        elink.download = result.tit;
        elink.style.display = "none";
        elink.href = result.downloadUrl;
        elink.target = "_self";
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      } else if (result.downloadUrl == "1") {
        return;
      } else {
        this.$message.warning("暂无下载地址");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  top: 64px;
  width: 100%;
  min-width: 1420px;
  background: #ffffff;
}
.row-box {
  width: 360px;
  height: 116px;
  min-height: 0 !important;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .row-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 12px;
    width: 336px;
    height: 56px;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background: #ededed;
    }
    .icon {
      width: 24.56px;
      height: 24px;
      margin-right: 8px;
    }
    .text {
      font-size: 16px;
      line-height: 24px;
      color: #292929;
    }
    .tip {
      font-size: 14px;
      line-height: 22px;
      color: #747e89;
      flex: 1;
      text-align: right;
    }
  }
}
.pDownload {
  width: 100%;
  height: 680px;
  background: linear-gradient(263.79deg, #f1f5ff 2.31%, #f7f9ff 100%);
  padding: 50px 0;
  .pDownload-text {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .pDownload-left {
      .text-box {
        .text1 {
          font-size: 64px;
          line-height: 88px;
          color: #292929;
        }
      }
      .text2 {
        font-size: 20px;
        line-height: 28px;
        color: #637392;
        margin-top: 20px;
      }
      .btn {
        cursor: pointer;
        margin-top: 50px;
        font-size: 20px;
        text-align: center;
        color: #ffffff;
        width: 164px;
        height: 54px;
        line-height: 54px;
        background: #336fff;
        box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
        border-radius: 6px;
        &:hover {
          background: #5c8cff;
          box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
        }
      }
    }
    .pDownload-right {
      width: 880px;
      height: 580px;
    }
  }
}

.downloadcode {
  width: 100%;
  // height: 1070px;
  padding: 20px 88px 88px;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  .downloadcode-tab {
    width: 1200px;
    // align-self: flex-start;
    display: flex;
    // width: 500px;
    padding: 10px 0;
    margin-bottom: 20px;
    border-bottom: 1px solid #cccccc;
    .active {
      font-weight: bold !important;
      color: #3d60dd !important;
    }
    .downloadcode-tab-item {
      cursor: pointer;
      margin-left: 20px;
      font-weight: 350;
      font-size: 20px;
      color: #353535;
    }
  }
  .downloadcode-container {
    width: 1200px;
    display: flex;
    // justify-content: space-around;
    flex-wrap: nowrap;
    .downloadcode-item {
      margin-right: 30px;
      // margin-bottom: 30px;
      width: 277px;
      height: 278px;
      background: #ffffff;
      box-shadow: 0px 0px 40px rgba(85, 152, 215, 0.12);
      border-radius: 10px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      &:last-child {
        margin-right: 0;
        // margin-bottom: 0;
      }
      .downloadcode-item-icon {
        margin-top: 30px;
        width: 130px;
        height: 130px;
        overflow: hidden;
        img {
          width: 130px;
          height: 130px;
        }
      }
      .downloadcode-item-tit {
        // margin-top: 20px;
        font-weight: 350;
        font-size: 18px;
        color: #353535;
      }
      .downloadcode-item-tip {
        cursor: pointer;
        box-sizing: border-box;
        // margin-top: 20px;
        width: 277px;
        height: 52px;
        box-shadow: 0px -0.5px 0px #cccccc;
        display: flex;
        align-items: center;
        justify-content: center;
        align-items: center;
        .downloadcode-item-tip-word {
          font-weight: 300;
          font-size: 14px;
          color: #353535;
        }
        img {
          margin-left: 10px;
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}
.shouy-box {
  width: 100%;
  height: 456px;
  background: #fafcff;
  padding: 40px 0;
  .shou-text {
    text-align: center;
    .text1 {
      font-size: 40px;
      line-height: 48px;
      color: #1f2329;
      margin-bottom: 16px;
    }
    .text2 {
      font-size: 18px;
      line-height: 28px;
      color: #51565d;
      margin-bottom: 16px;
    }
    .text3 {
      .span1-t {
        font-size: 13px;
        line-height: 22px;
        color: #8f959e;
      }
      .xian {
        display: inline-block;
        width: 1px;
        height: 12px;
        background: #dee0e3;
        margin: 0 26px;
      }
      .span2-t {
        font-size: 13px;
        line-height: 22px;
        color: #8f959e;
      }
      .span3-t {
        font-size: 13px;
        line-height: 22px;
        color: #3370ff;
      }
    }
  }
  .shou-img-box {
    width: 932px;
    margin: 40px auto;
    display: flex;
    justify-content: space-between;
    // align-items: center;
  }
  .three-img-box {
    width: 540px;
    margin: 20px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .shou-img {
    width: 148px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    .div-img {
      box-shadow: 0px 2px 16px rgba(28, 76, 186, 0.08);
      width: 148px;
      height: 148px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .down-btn {
      margin-top: 10px;
      background-color: #336fff;
      &:hover {
        background-color: #4080ff;
      }
    }
    .div-img1 {
      box-shadow: 0px 2px 16px rgba(28, 76, 186, 0.08);
      width: 148px;
      height: 148px;
      display: flex;
      align-items: center;
      justify-content: center;
      .img {
        width: 116px;
        height: 116px;
      }
    }
    .te {
      text-align: center;
      margin-top: 24px;
      font-size: 16px;
      line-height: 28px;
      color: #353535;
    }
    .tong {
      margin-top: 4px;
      margin: 0 auto;
      width: 130px;
      height: 22px;
      background: #f0f4ff;
      border-radius: 4px;
      font-size: 13px;
      color: #3370ff;
      text-align: center;
      line-height: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/download.vue